import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { parse } from 'url';
import { UserService } from '../services/user.service';
import { Location } from '@angular/common';
import { NgForm, FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User, UserDetails } from '../feature-modules/admin/user/modals/user.modal';
import { subscribeOn } from 'rxjs/operator/subscribeOn';
import { Router } from '@angular/router';
import { EncriptDecriptService } from '../services/encriptdecript';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit,AfterViewInit {
  userId: any;
  loginData: any;
  profileObj: any;
  user: User = new User()
  userDetails:UserDetails =new UserDetails();

  userProfileFormGroup: FormGroup;
  // tslint:disable-next-line:max-line-length
  public mobileNumberMask = ['(', /[0-9]/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  private underscore_hiphen_space_alpha_num_only = '[a-zA-Z0-9 _-]*';
  private underscore_hiphen_alpha_num_only = '[a-zA-Z0-9_-]*';
  private emailRegex = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';
  date: Date;
  savedobj: Object;
  orgName: any;
  userObject:any;
  constructor(private userService: UserService,
     private _location: Location, 
     private userprofileService:UserService,private router:Router,
     private formBuilder: FormBuilder,private encriptDecript:EncriptDecriptService) {
      this.userObject =this.encriptDecript.getLocalStorage('userObject');
      }

  ngOnInit() {
    this.gitUserProfiles()
    this.userProfileForm();
  }

ngAfterViewInit(){
  this.userProfileSubscribe()
}

userProfileSubscribe(){
this.userProfileFormGroup.valueChanges.subscribe(values=>{
     
})
}

  userProfileForm() {
    this.userProfileFormGroup = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern(this.underscore_hiphen_space_alpha_num_only)]],
      lastName: ['', [Validators.required, Validators.pattern(this.underscore_hiphen_space_alpha_num_only)]],
      country: ['', Validators.required],
      emailId: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      userName: [''],
      city: ['', Validators.required],
      description: ['', Validators.required],
      userDetails: this.formBuilder.group({
        address: ['', Validators.required,],
        mobileNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
        phoneNumber: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10)]],
      })
    })
  }

  backClicked() {
    // this._location.back();
    this.router.navigate(['/user/dashboard/browse']);
  }

  gitUserProfiles() {
    this.loginData = JSON.parse(this.userObject);
    this.userId = this.loginData.userId;
    this.userService.getProfileObject(this.userId).subscribe(response => {
      this.user = <User>response.data;
      this.orgName= response.data.organisation.name;
      this.userProfileFormGroup.patchValue({
        userDetails: {
          address: response.data.userDetails[0]["address"],
          phoneNumber: response.data.userDetails[0]["phoneNumber"],
          mobileNumber: response.data.userDetails[0]["mobileNumber"]
        },
      });
    });
  }

  onSubmit(){
    this.user.userName = "";
    this.user.firstName = this.firstName.value;
    this.user.lastName = this.lastName.value;
    
    this.user.city = this.city.value;
    this.user.country = this.country.value;
    this.user.emailId = this.emailId.value;
    this.user.description =this.description.value; 
    
    
    const userDetailsArray: UserDetails[] = [];
    
    this.userDetails.address = this.address.value;
    this.userDetails.phoneNumber = this.phoneNumber.value;
    this.userDetails.mobileNumber = this.mobileNumber.value;
    this.userDetails.isActive = this.user.isActive;
    this.userDetails.createdBy=1;
    this.userDetails.createdOn=this.date;
    this.userDetails.userDetailsId=this.user.userDetails[0].userDetailsId;
    userDetailsArray.push(this.userDetails);
    this.user.userDetails = userDetailsArray;
      const orgName = this.orgName;
      this.userprofileService.saveUser(this.user ,orgName).subscribe((response) => {
        this.savedobj =response;
        this.backClicked()
         });

  }
  public get userName(): AbstractControl {
    return this.userProfileFormGroup.get('userName');
  }

  public get firstName(): AbstractControl {
    return this.userProfileFormGroup.get('firstName');
  }

  public get lastName(): AbstractControl {
    return this.userProfileFormGroup.get('lastName');
  }

  public get emailId(): AbstractControl {
    return this.userProfileFormGroup.get('emailId');
  }

  public get city(): AbstractControl {
    return this.userProfileFormGroup.get('city');
  }


  public get country(): AbstractControl {
    return this.userProfileFormGroup.get('country');
  }


  public get description(): AbstractControl {
    return this.userProfileFormGroup.get('description');
  }

  public get phoneNumber(): AbstractControl {
    return this.userProfileFormGroup.get('userDetails').get('phoneNumber');
  }

  public get mobileNumber(): AbstractControl {
    return this.userProfileFormGroup.get('userDetails').get('mobileNumber');
  }


  public get address(): AbstractControl {
    return this.userProfileFormGroup.get('userDetails').get('address');
  }



}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-profile/user-profile.component.ts